var exports = {
  "kL": "DiscoverySidebar.module__container___Q1JZcT",
  "CT": "DiscoverySidebar.module__navList___Q1JZcT",
  "pc": "DiscoverySidebar.module__navItem___Q1JZcT",
  "HW": "DiscoverySidebar.module__navItemActive___Q1JZcT",
  "T1": "DiscoverySidebar.module__navItemDisabled___Q1JZcT",
  "wz": "DiscoverySidebar.module__navItemIcon___Q1JZcT",
  "hk": "DiscoverySidebar.module__navItemLabel___Q1JZcT",
  "WG": "DiscoverySidebar.module__comingSoonBadge___Q1JZcT",
};

module.exports = exports;
